import React, { Component } from 'react'

class Input extends Component<{}> {
  constructor(props){
    super(props)
    this.state = {
      value: this.props && this.props.value ? this.props.value : ''
    }
    this.input = React.createRef();
    this.underline = React.createRef();
    this.label = React.createRef();
  }
  selected = () =>{
    this.underline.current.style.width = '100%'
    this.label.current.style.transform = 'translate(0, -20px) scale(.75)'
  }
  deselected = () => {
    if(this.props.value === '' || this.props.value === undefined || this.props.value === null){
      this.underline.current.style.width = 0
      this.label.current.style.transform = 'translate(0, 0px)'
    }
  }
  handleChange = () => {
    let value = this.input.current.value
    if(this.props.accepts === 'int'){
      console.log('Handling change while only accepting int')
      if(isNaN(this.input.current.value) || this.input.current.value > (this.props.intLimit || 40)){
        return false
      }
    }
    this.setState({value})
    if(this.props.onChange) this.props.onChange({value, prop: this.props.name})
  }
  componentWillReceiveProps(nuProps){
    if((this.props.value !== '' || this.props.value !== null ) && this.props.value !== nuProps.value){
      this.selected()
    }
  }
  componentDidMount(){
    if(this.props.value !== (null || '')){
      this.selected()
    }
  }
  render() {
    return (
      <span className="input-outer-wrap" style={{width: this.props.width || 'auto', marginLeft: this.props.style ? this.props.style.marginLeft : null}}>
        <label 
          ref={this.label}
          style={{
            left: this.props.icon ? 27 : 0,
            color: this.props.placeholderColor || this.props.color || '#fff',
            fontSize: this.props.style && this.props.style.fontSize ? this.props.style.fontSize : 24
          }}
          className="input-label">
            {this.props.placeholder}
        </label>
        {
          this.props.icon && <i style={{position: 'absolute', left: this.props.iconOffsetLeft || 4, color: this.props.color || '#fff', fontSize: 18}} className={'input-icon '+this.props.icon}></i>
        }
        <input
          ref={this.input}
          id={this.props.id}
          disabled={this.props.disabled}
          className="input-element"
          type={ this.props.type ? this.props.type : 'text'}
          value={this.props.value}
          onSelect={this.selected}
          onBlur={this.deselected}
          onChange={this.handleChange}
          style={{
            color: this.props.color || '#fff',
            paddingLeft: this.props.icon ? 27 : 0,
            caretColor: this.props.color || '#fff',
            maxWidth: this.props.width || '100%',
            width: '100%',
            fontSize: this.props.style && this.props.style.fontSize ? this.props.style.fontSize : 24
          }}
        />
        <span style={{
          background: this.props.color || '#fff'
        }} ref={this.underline} className="input-element-underline"></span>
        <span style={{
          background: this.props.color || '#fff'
        }} className="input-element-underline-bg"></span>
      </span>
    )
  }
}

export default Input